export interface Account {
	firstName: string;
	lastName: string;
	fullName: string;
	email: string;
	roles: string[];
	isActivated: boolean;
}

export interface AccountInfo {
	creationDate: Date;
	accountActivated: boolean;
	estimateSigned: boolean;
	activationEmailResendDate: Date;
	activationLink: string;
	email: string;
}

export enum AccountStatusEnum {
	ACTIVATED = 'ACTIVATED',
	NOT_ACTIVATED = 'NOT_ACTIVATED'
}
